module.exports = __webpack_public_path__ + "0ac82d4ea15c2d5a7b310dc8e53b076d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/overalls-denim.png
// module id = 1360
// module chunks = 0